import { render, staticRenderFns } from "./AddWatchersRef.vue?vue&type=template&id=5ca17e12&"
import script from "./AddWatchersRef.vue?vue&type=script&lang=js&"
export * from "./AddWatchersRef.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/locales/components/WatchersTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fcomponents%2Fadd-watchers-ref%2FAddWatchersRef.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports